import AuthConfig from '../config/AuthConfig';
import { setRplusEpubCloudfrontCorsWorkaroundActive } from './CloudfrontCorsLocalWorkaround';
import { isRplusEpubTitleType } from './RplusEpubPreviewUtils';

export const bindRplusEpubPreviewAuth = (titleType) => {
  const active = isRplusEpubTitleType(titleType);
  setRplusEpubCloudfrontCorsWorkaroundActive(active);
  return new AuthConfig({ useRplusEpubAuth: active }).getAuthConfig();
};

export const unbindRplusEpubPreviewAuth = () => {
  setRplusEpubCloudfrontCorsWorkaroundActive(false);
};
